module.exports = __webpack_public_path__ + "img/20200408143218320.8162b242.png";